import { render, staticRenderFns } from "./err_device.vue?vue&type=template&id=6ffafe92&scoped=true&"
import script from "./err_device.vue?vue&type=script&lang=js&"
export * from "./err_device.vue?vue&type=script&lang=js&"
import style0 from "./err_device.vue?vue&type=style&index=0&id=6ffafe92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffafe92",
  null
  
)

export default component.exports